export const OWNER = 'owner';
export const ADVERTISER = 'advertiser';
export const REFERRER = 'influencer';
export const REFERRER_CONVERTER = 'referrer_converter';
export const CONVERTER = 'converter';
export const GUEST = 'guest';
export const INVITED = 'invited';
export const LIKES = 'likes';
export const LINKS = 'links';
